<template>
  <div class="maintenanceRecords_container">
    <div class="top-layout" v-if="dataList || !noAddBt">
      <el-input :class="buttonPerms.indexOf('h5/addMaintenanceRecords') > -1 ? 'keyWord' : 'keyWord1'"  v-model="query.ebikeCode"  prefix-icon="el-icon-search" :placeholder="$t('account.name22')">
      </el-input>
      <div :class="buttonPerms.indexOf('h5/addMaintenanceRecords') > -1 ? 'search' : 'search1'" @click="getPageList">{{ $t('operate.name80') }}</div>
      <el-button class="add-bt"   type="primary" icon="el-icon-plus" @click="addMaintenanceRecords" v-if="buttonPerms.indexOf('h5/addMaintenanceRecords') > -1">{{ $t('manage.name74') }}</el-button>
    </div>
    <div class="content-list" v-if="dataList" @scroll="handleScroll">
        <div class="content-item" v-for="(item, index) in dataList" :key="index">
          <div class="item-date-fp">
            <div class="date"><i class="el-icon-date"></i> {{ item.createTime }}</div>
          </div>
          <!-- <div class="item-three"><span>{{ $t('bike.name150') }}</span>{{ item.manufacturerTenantName }}</div> -->
          <div class="item-three"><span>{{ $t('bike.name295') }}</span>{{ item.ebikeCode }}</div>
          <div class="item-three"><span>{{ $t('bike.name2') }}</span>{{ item.ebikeModelId }}</div>
          <div class="item-lx"><div>{{ $t('bike.name467') }}</div><span  v-for="(items, indexs) in item.partList" :key="indexs">{{ items.maintainTypeName }}</span></div>
          <div class="item-two">
            <div class="two-items" v-for="(items, indexs) in item.partList1" :key="indexs">
            <div class="items" v-if="items.newPartCode"><span>{{ items.maintainTypeName }}{{ $t('account.name28') }}</span>{{ items.newPartCode }}</div>
            <div class="items" v-else><span>{{ items.maintainTypeName }}</span></div>
           </div>
          </div>
          <div class="item-one">
            <div class="item-img" v-for="(items, indexs) in item.filePathList" :key="indexs">
              <img :src="items" @click="showImgPreview(item.filePathList,indexs)"/>
            </div>
          </div>
        </div>
        <div class="no-more-data" v-if="allLoaded">{{ $t('account.name24') }}</div>
    </div>
    <div v-if="noData" class="no-data">
      <img src="@/assets/no-sale.png"/>
      <div class="text">
        {{ $t('account.name15') }}
      </div>
      <el-button type="primary" @click="addMaintenanceRecords" v-if="buttonPerms.indexOf('h5/addMaintenanceRecords') > -1 && noAddBt"> {{ $t('account.name16') }}</el-button>
    </div>
    <van-image-preview v-model="showPreview" :images="imgList" :start-position="startPosition" class="image-preview"  @change="onChange">
      <template slot="index">{{ index }}/{{ imgList.length }}</template>
  <template slot="cover"><i class="el-icon-close" @click="closePreview"></i></template>
</van-image-preview>
  </div>
</template>
<script>
import { queryMaintainRecordPage } from '@/api/h5.js'
import Vue from 'vue'
import 'vant-green/lib/index.css'
import { ImagePreview } from 'vant-green'
Vue.use(ImagePreview)
export default {
  data() {
    return {
      buttonPerms: '',
      query: {
        ebikeCode: '',
        pageSize: 10,
        pageNumber: 1
      },
      allLoaded: false,
      showPreview: false,
      imgList: [],
      index: 1,
      startPosition: 0,
      dataList: null,
      noData: false,
      noAddBt: false
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    handleScroll(event) {
      const container = event.target
      const scrollTop = container.scrollTop
      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight
      // 如果滚动到底部，并且没有在加载中
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.allLoaded) {
        this.query.pageNumber++
        this.allLoaded = true
        this.getMaintainRecordPage()
      }
    },
    clickTab(index) {
      this.clickIndex = index
    },
    addMaintenanceRecords() {
      this.$router.push('/addMaintenanceRecords')
    },
    getMaintainRecordPage() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name44'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      queryMaintainRecordPage(this.query).then((res) => {
        if (res.code === 200) {
          const list = []
          res.data.page.records.map((item) => {
            var obj = {}
            obj.createTime = item.createTime
            obj.ebikeCode = item.ebikeCode
            obj.manufacturerTenantName = item.manufacturerTenantName
            obj.ebikeModelId = item.ebikeModelId
            obj.partList = item.partList
            obj.filePathList = item.filePathList
            obj.partList1 = []
            item.partList.map((items) => {
              if (items.maintainType !== '6') {
                obj.partList1.push(items)
              }
            })
            list.push(obj)
            this.dataList = this.dataList.concat(list)
          })
          if (res.data.page.records.length < this.query.pageSize) {
            this.allLoaded = true
          } else {
            this.allLoaded = false
          }
        }
        loading.close()
      })
    },
    getPageList() {
      this.query.pageNumber = 1
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name44'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      queryMaintainRecordPage(this.query).then((res) => {
        if (res.code === 200) {
          if (res.data.page.records.length > 0) {
            // this.dataList = res.data.page.records
            const list = []
            res.data.page.records.map((item) => {
              var obj = {}
              obj.createTime = item.createTime
              obj.manufacturerTenantName = item.manufacturerTenantName
              obj.ebikeCode = item.ebikeCode
              obj.ebikeModelId = item.ebikeModelId
              obj.filePathList = item.filePathList
              obj.partList = item.partList
              obj.partList1 = []
              item.partList.map((items) => {
                if (items.maintainType !== '6') {
                  obj.partList1.push(items)
                }
              })
              list.push(obj)
              this.dataList = list
            })

            this.noData = false
          } else {
            this.dataList = null
            this.noData = true
            if (this.query.ebikeCode) {
              this.noAddBt = false
            } else {
              this.noAddBt = true
            }
          }
          if (res.data.page.records.length < this.query.pageSize) {
            this.allLoaded = true
          }
        }
        loading.close()
      })
    },
    showImgPreview(imgList, index) {
      this.onChange(index)
      this.imgList = imgList
      this.showPreview = true
    },
    onChange(index) {
      this.index = index + 1
      this.startPosition = index
    },
    closePreview() {
      this.showPreview = false
    }
  }
}
</script>
<style lang="scss">
.maintenanceRecords_container{
.top-layout{
  height: 54px;
  .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 100px;
  background: #f5f5f5;
  border: 0px solid #DCDFE6;
}
}
}
.el-loading-mask{
  top: 54px;
  bottom: 60px;
}
.van-image-preview img {
  max-width: 100%;
  height: auto;
}
.van-image-preview__image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* 或其他适合你布局的高度 */
}
.van-image-preview__overlay {
  background-color: rgba(0,0,0,0.6);
}
.van-image-preview__index{
  top: 52px;
}
</style>
<style lang="scss" scoped>
.maintenanceRecords_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  .image-preview{
    .el-icon-close{
      color: #fff;
      font-size:24px;
      font-weight: 800;
      position: fixed;
      right: 15px;
      top: 48px;
    }
  }
  .no-data{
    width: 100%;
    height: calc(100vh - 168px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img{
      width: 122px;
      height: 122px;
    }
    .text{
      color: #555;
      font-size: 14px;
      margin-top: 20px;
      margin-bottom: 33px;
    }
  }
  .content-list{
    width: 100%;
    height: calc(100vh - 168px);
    overflow: auto;
    display: flex;
    padding: 15px;
    flex-direction: column;
    .no-more-data{
      width: 100%;
      text-align: center;
      font-size: 14px;
    }
    .content-item{
      width: 100%;
      background: #fff;
      // height: 252px;
      display: flex;
      flex-direction: column;
      padding: 10px;
      margin-bottom: 15px;
      // padding: 10px;
      .item-date-fp{
        width: 100%;
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #DDDEE1;
        margin-bottom: 10px;
        font-size: 17px;
        font-weight: 600;
        color: #000000;
        .el-icon-date{
          font-size: 20px;
          font-weight: 600;
          margin-right: 8px;
        }
        .date{
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .fp{
          color: #555;
        }
      }
      .item-lx{
        width: calc(100vw - 30px);
        font-size: 15px;
        margin-top: 8px;
        color: #999;
        display: flex;
        flex-direction: row;
        overflow-x: scroll;
          span{
            color: #0F73E6;
            margin-right: 5px;
          }
      }
      .item-one{
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        flex-wrap: wrap;
        margin-left: -10px;
        .item-img{
          width: calc(25vw - 25px);
          height: calc(25vw - 25px);
          margin-top: 10px;
          margin-left: 10px;
          img{
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        }
      }
      .item-two{
        width: 100%;
        display: flex;
        flex-direction: column;
        // flex-wrap: wrap;
        font-size: 15px;
        color: #555;
        .two-items{
          width: 100%;
          display: flex;
          flex-direction: column;
        }
        .items{
          width: 100%;
          margin-top: 8px;
          span{
            color: #999;
          }
        }
      }

      .item-three{
        width: 100%;
        font-size: 15px;
        margin-top: 8px;
        color: #555;
          span{
            color: #999;
          }
      }
    }
  }
  .top-layout{
    height: 54px;
    display: flex;
    // width: 100%;
    padding-left: 15px;
    // justify-content: center;
    align-items: center;
    background: #fff;
    color: #171717;
    font-size: 16px;
    font-weight: 500;
    position: relative;
    .keyWord{
      width: calc(100vw - 140px);
    }
    .keyWord1{
      width: calc(100vw - 30px);
    }
    .add-bt{
      // margin-right: 15px;
      width: 100px;
      margin-left: 10px;
      border-radius: 100px;
      height: 34px;
      padding: 0px;
      line-height: 34px;
    }
    .search{
      position: absolute;
      right: 126px;
      // top: 7px;
      width: 70px;
      height: 34px;
      background: #FFFFFF;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .search1{
      position: absolute;
      right: 16px;
      // top: 7px;
      width: 70px;
      height: 34px;
      background: #FFFFFF;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .middle-content{
    background: #F6F7FB;
    display: flex;
    height: 100%;
    overflow: auto;
  }
  .bottom-tab{
    background: #fff;
    height: 40px;
    width: 100%;
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    .item-tab{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      cursor: pointer;
    }
    .color1{
      color: #555;
    }
    .color2{
      color: #0F73E6;
    }
  }
}
</style>
